// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__17U1q","vLegacy":"SelectSecondary_vLegacy__1LmfT","error":"SelectSecondary_error__2A5Zy","disabled":"SelectSecondary_disabled__6eUyS"};